import options from './thing-folders.component';

export default {
    selector: 'dtAsThingFolders',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-folders/index.js